import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import * as store from 'store';
import CustomerDetails from '../components/CustomerDetails';
import Header from '../components/Header';
import OrderActionButtons from '../components/OrderActionButtons';
import OrderDetailSection from '../components/OrderDetailSection';
import Receipt from '../components/Receipt';
import VendorShoppingList from '../components/VendorShoppingList';
import { SpotlightPermission } from 'types/enums';

interface ParamTypes {
  orderID: string;
}
interface OrdersProps {}
interface IState {
  externalOrderID: string;
  shopper: string;
  isCompleted: string;
  customerType: string;
  orderTypeID: string;
  shopName: string;
  startTime: string;
  shoppingCompleted: string;
  deliveryStarted: string;
  deliveryCompleted: string;
  agentID: string;
  firstItemPickedTime: null | string;
}

const Orders: React.FC<OrdersProps> = (props) => {
  const location = useLocation();
  let { orderID } = useParams<ParamTypes>();
  const externalOrderID = (location.state as IState).externalOrderID;
  const shopper = (location.state as IState).shopper;
  const isCompleted = (location.state as IState).isCompleted;
  const customerType = (location.state as IState).customerType;
  const orderTypeID = (location.state as IState).orderTypeID;
  const shopName = (location.state as IState)?.shopName;
  const startTime = (location.state as IState)?.startTime;
  const shoppingCompleted = (location.state as IState)?.shoppingCompleted;
  const deliveryStarted = (location.state as IState)?.deliveryStarted;
  const deliveryCompleted = (location.state as IState)?.deliveryCompleted;
  const agentID = (location.state as IState)?.agentID;
  const firstItemPickedTime = (location.state as IState)?.firstItemPickedTime;

  const [permissions, setPermissions] = useState<string[]>([]);

  useEffect(() => {
    const getPermissions = async () => {
      const userPermissions: string[] = store.get('permissions');

      if (userPermissions) setPermissions(userPermissions);
    };
    getPermissions();
  }, []);

  return (
    <React.Fragment>
      <Header {...props} />
      <Container style={{ paddingTop: '20px', height: '100%' }} maxWidth={false}>
        <Grid container spacing={3}>
          {permissions?.includes(SpotlightPermission.EDIT_ORDER) &&
            permissions?.includes(SpotlightPermission.ASSIGN_AGENT) && (
              <Grid item xs={12} sm={12}>
                <OrderActionButtons shopper={shopper} orderID={orderID} />
              </Grid>
            )}
          <Grid container direction="column" style={{ height: '100%' }} item xs={12} sm={4}>
            <CustomerDetails customerType={customerType} orderID={orderID} />
            <OrderDetailSection
              orderTypeID={orderTypeID}
              isCompleted={isCompleted}
              orderID={orderID}
              externalOrderID={externalOrderID}
              shopName={shopName}
              startTime={startTime}
              shoppingCompleted={shoppingCompleted}
              deliveryStarted={deliveryStarted}
              deliveryCompleted={deliveryCompleted}
              agentID={agentID}
              firstItemPickedTime={firstItemPickedTime}
            />
          </Grid>
          <Grid item xs={12} sm={7}>
            {isCompleted ? (
              <Receipt orderTypeID={orderTypeID} isCompleted={isCompleted} orderID={orderID} />
            ) : (
              <VendorShoppingList />
            )}
          </Grid>
        </Grid>
      </Container>
    </React.Fragment>
  );
};

export default Orders;
